import { LESSON_TYPES } from '../data/lessonTypes';

const hasLiveLecture = (lessons) => {
  return lessons.find(
    (lesson) => lesson.lesson_type === LESSON_TYPES.liveLecture
  );
};

export default hasLiveLecture;
